<template>
  <a-modal v-if="visible" v-model="visible" title="附加要求" @ok="handleOk">
    <ul class="tag-list">
      <!-- <li v-for="tags in skills" :key="tags.id"> -->
        <!-- <h3>{{ tags.skill_name }}</h3> -->
        <template v-for="tag in skills">
          <a-checkable-tag
            style="border: #35B5FE 1px solid; margin-bottom: 10px;"
            :key="tag.id"
            :checked="tag.is_default == '1' ? true : false"
            @change="checked => handleChangeTags(tag, checked)"
          >
            {{ tag.skill_name }}
          </a-checkable-tag>
        </template>
      <!-- </li> -->
    </ul>
  </a-modal>
</template>

<script>
export default {
  name: "tags-modal",
  data() {
    return {
      type: '',
      skills: [],
      visible: false,
    }
  },
  methods: {
    async show(skills, type) {
      this.skills = skills;
      this.type = type;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleChangeTags(tag, checked) {
      console.log(tag, checked);
      tag.is_default = checked ? '1' : '0';
    },
    handleOk() {
      this.close();
      this.$emit("ok", this.skills, this.type);
    }
  },

};
</script>

<style lang="scss" scoped>

</style>
